import { render, staticRenderFns } from "./ActivityTable.vue?vue&type=template&id=11ba15e5&scoped=true"
import script from "./ActivityTable.vue?vue&type=script&lang=js"
export * from "./ActivityTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ba15e5",
  null
  
)

export default component.exports